import localStorageEx from 'bundles/common/utils/localStorageEx';

import _t from 'i18n!nls/account-profile';

export type Occupation = {
  label: string;
  id: string;
};

export function getOccupationLabelWithId(id: string, occupations: Occupation[]) {
  const occupationData = occupations.find((occupation) => occupation.id === id);

  if (occupationData?.id === 'software-developer-engineer') {
    return _t('Software Developer');
  }

  return occupationData?.label || '';
}

export const getViewProjectDialogTranslations = () => ({
  notification: _t(
    'Give employers a clear picture of your thought process by adding details about the decisions you made and the steps you took to complete the project.'
  ),
  summaryTitle: _t('Summary'),
  approachTitle: _t('Approach'),
  solutionTitle: _t('Solution'),
  summaryPlaceholder: _t(
    'Add a project summary here so that recruiters understand the context of the work you are presenting, and to help you stand out from other solutions.'
  ),
  solutionPlaceholder: _t(
    'Give recruiters a quick introduction to your project on your profile. To stand out from other candidates, use this space to clearly and concisely describe the key techniques you used and the potential business impact of your work.'
  ),
  approachPlaceholder: _t(
    'Give a clear picture of your thought process by adding details about the decisions you made and the steps you took to complete the project.'
  ),
  projectScenarioTitle: _t('Project scenario'),
  skillsDemonstratedTitle: _t('Skills demonstrated'),
  toolsUsedTitle: _t('Tools used'),
  projectLinksTitle: _t('Project link(s)'),
  editProjectBtnLabel: _t('Edit project'),
});

export const LAST_DISMISSED_PROJECT_COMPLETION_DIALOG = 'account-profile_lastDismissedProjectCompletionDialog';

export function hasCompletionDialogBeenDismissed(projectId: string) {
  const savedLocalStorageValue = localStorageEx.getItem(LAST_DISMISSED_PROJECT_COMPLETION_DIALOG, JSON.parse, null);
  return savedLocalStorageValue === projectId;
}

export function setLastDismissedCompletionDialogProjectId(projectId: string) {
  localStorageEx.setItem(LAST_DISMISSED_PROJECT_COMPLETION_DIALOG, projectId, JSON.stringify);
}
